import React, { FC } from 'react'
import { Navigate, Outlet, Route } from 'react-router-dom'
import { FcHome } from 'fc/pages/home/FcHome'
import {
    FcProfile,
    FcVillage,
    VillageProfile,
    VeProfile,
    EnrollmentDashboard
} from 'fc/pages'
import {
    ClientPaymentHistory,
    ClientSearch,
    VillageClientDetails,
    VillagePrevClientDetails,
    Visit,
    GPSWarning,
    BulkEnrollmentPackageSelection,
    BulkEnrollmentEntry,
    BulkEnrollmentConfirmation,
    BulkEnrollmentLayout,
    MobileMoney
} from 'pages'
import { FcSearchResults } from 'fc/pages/search/FcSearchResults'
import EnrollmentBase from 'pages/enrollment/v3/EnrollmentBase'
import { VillageClientWrapper } from 'fc/pages/village/VillageClientWrapper'

const ConnectRoutes = () => {
    const VillagePrevClientDetailsPage = VillagePrevClientDetails as FC

    return (
        <>
            <Route path="/" element={<Navigate replace to="/fc/home" />} />
            <Route path="/fc" element={<Outlet />}>
                <Route path="home" element={<FcHome />} />
                <Route path="profile" element={<FcProfile />} />
                <Route path="village" element={<Outlet />}>
                    <Route path="" element={<FcVillage />} />
                    <Route
                        path=":veVillageId/profile/:veCode"
                        element={<VillageProfile />}
                    />
                    <Route
                        path=":veVillageId/profile"
                        element={<VillageProfile />}
                    />
                    <Route path="ve/:veCode/profile" element={<VeProfile />} />
                    <Route
                        path=":veVillageId/enrollment-recap/:veCode"
                        element={<EnrollmentDashboard />}
                    />
                    <Route
                        path=":veVillageId/enrollment-recap"
                        element={<EnrollmentDashboard />}
                    />
                </Route>
                <Route path="village" element={<FcVillage />} />
                <Route path="ve-search/results" element={<FcSearchResults />} />
            </Route>
            <Route path="village" element={<Outlet />}>
                <Route path=":villageId" element={<VillageClientWrapper />} />
                <Route path=":villageId" element={<Outlet />}>
                    <Route
                        path="bulk-enrollment"
                        element={<BulkEnrollmentLayout />}
                    >
                        <Route
                            path="packages"
                            element={<BulkEnrollmentPackageSelection />}
                        />
                        <Route path="entry" element={<BulkEnrollmentEntry />} />
                        <Route
                            path="confirmation"
                            element={<BulkEnrollmentConfirmation />}
                        />
                    </Route>
                    <Route
                        path="client/:clientId"
                        element={<VillageClientDetails />}
                    />
                    <Route path="client/:clientId" element={<Outlet />}>
                        <Route
                            path="payment-history"
                            element={<ClientPaymentHistory />}
                        />
                        <Route path="previous" element={<Outlet />}>
                            <Route
                                index
                                element={<VillagePrevClientDetailsPage />}
                            />
                            <Route
                                path="payment-history"
                                element={<ClientPaymentHistory />}
                            />
                        </Route>
                    </Route>
                </Route>
            </Route>
            <Route path="enroll/:villageId" element={<EnrollmentBase />} />
            <Route path="client-search" element={<ClientSearch />} />
            <Route path="visit" element={<Visit />} />
            <Route path="gpswarning" element={<GPSWarning />} />
            <Route path="mobile-money" element={<Outlet />}>
                <Route path="payment" element={<MobileMoney />} />
            </Route>
        </>
    )
}

export default ConnectRoutes
